export default "__VITE_ASSET__70d93fa5__"